import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, Flex, Menu, MenuProps, Typography } from 'antd';

import TelegramIcon from 'assets/images/icons/telegram-outlined.svg?react';
import { BOT_URL } from 'features/Telegram';
import { useGetAppConfigQuery } from 'shared/api';

interface ISupportNavProps extends MenuProps {}

export const SupportNav: FC<ISupportNavProps> = ({ className, ...props }) => {
	const { t } = useTranslation();
	const { data: appConfig } = useGetAppConfigQuery();
	const managerTelegram = appConfig?.user?.manager_telegram_url || 'https://t.me/affilead_manager';

	const [dots, setDots] = useState({
		telegramBotDotHidden: !!localStorage.getItem('telegramBotDotHidden'),
		telegramManagerDotHidden: !!localStorage.getItem('telegramManagerDotHidden'),
	});

	const hideDot = (key: string) => {
		localStorage.setItem(key, 'true');
		setDots((prev) => ({ ...prev, [key]: true }));
	};

	const items = [
		{
			label: (
				<Flex align="center" gap={8}>
					<Typography.Link href={BOT_URL} target="_blank">
						{t('Бот в Telegram')}
					</Typography.Link>
					{!dots.telegramBotDotHidden && <Badge status="error" />}
				</Flex>
			),
			key: 'telegramBot',
			icon: <TelegramIcon />,
			onMouseEnter: () => hideDot('telegramBotDotHidden'),
			onClick: () => hideDot('telegramBotDotHidden'),
		},
		{
			label: (
				<Flex align="center" gap={8}>
					<Typography.Link href={managerTelegram} target="_blank">
						{t('Менеджер в Telegram')}
					</Typography.Link>
					{!dots.telegramManagerDotHidden && <Badge status="error" />}
				</Flex>
			),
			key: 'telegramManager',
			icon: <TelegramIcon />,
			onMouseEnter: () => hideDot('telegramManagerDotHidden'),
			onClick: () => hideDot('telegramManagerDotHidden'),
		},
	];

	return <Menu {...props} className={className} inlineIndent={16} mode="inline" items={items} selectable={false} />;
};
